<template>
    <div class="container">
        <b-row class="mb-3 align-items-center">
            <b-col cols="1"></b-col>
            <b-col cols="3" class="text-left">
                <label class="password-policy-item">
                    {{ labels.calificacion }}
                </label>
            </b-col>
            <b-col cols="2" class="text-left">
                <span class="font-weight-bold text-primary">
                    {{ calificacion || '-' }}
                </span>
            </b-col>
            <b-col cols="6" class="text-left">
                <label class="password-policy-item">
                    Score
                </label>
                <b-form-select
                    v-model="zscore"
                    :options="scoreOptions"
                    @click="f_lea_informacion"
                    class="reset-select"
                >
                    <template #first>
                        <b-form-select-option
                            :value="null"
                            disabled
                        >
                            {{ labels.selectScore }}
                        </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
        </b-row>
        <div
            v-if="muestraInformacion"
            class="row col-md-12 justify-content-center mt-3"
        >
            <CorporateDataTable
                :items="tableData"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
            >
                <template #column-tasa="{ item }">
                    <span
                        v-if="item.tasa"
                        class="font-weight-bold"
                    >
                        {{ item.tasa }}
                    </span>
                    <span
                        v-else
                        class="text-muted"
                    >
                        -
                    </span>
                </template>
                <template #column-valor="{ item }">
                    <span
                        v-if="item.valor !== null && item.valor !== undefined && item.valor !== ''"
                        class="text-right font-weight-bold"
                    >
                        {{ item.valor }}
                    </span>
                    <span
                        v-else
                        class="text-muted"
                    >
                        -
                    </span>
                </template>
            </CorporateDataTable>
            <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button
                    class="reset-btn-primary"
                    @click="f_guardarTasa"
                >
                    {{ labels.save }}
                </b-button>
            </div>
        </div>
        <div
            v-else
            class="text-center text-muted py-4"
        >
            <span>
                {{ labels.info }}
            </span>
        </div>
    </div>
</template>
<script>
import CorporateDataTable from '../../utils/CorporateDataTable.vue';
import ClasificacionTasas from '../../../services/ClasificacionTasas';
import Score from '../../../services/Score';
import TipoTasa from '../../../services/TipoTasas';
import Tasas from '../../../services/Tasas';


export default {
    name: 'Tasas',
    components: {
        CorporateDataTable
    },
    props: {

        infoVigencia: {
            type: String,
            default: ''
        }

    },
    data() {
        return {
            listaTasas: [],
            TasasByVigencia: {
                tasa_usa: '',
                embi: '',
                tasa_libre_riesgo: '',
                inflacion_usa: '',
                inflacion_col: '',
                calificacion: '',
                vigencia: '',
                tipo_tasa: ''
            },
            calificacion: '',
            listTasasScore: [],
            zscore: null,
            muestraInformacion: false,
            loading: false,
            tableData: [],
            tableHeaders: [

                {
                    text: 'Tasa',
                    value: 'tasa',
                    sortable: false
                },

                {
                    text: 'Valor',
                    value: 'valor',
                    sortable: false,
                    class: 'text-right'
                },

                {
                    text: '',
                    value: 'acciones',
                    sortable: false,
                    class: 'text-center'
                }

            ]

        };

    },
    computed: {

        labels() {

            if (this.$store.state._language == "es-ES") {

                return {
                    title: 'Tasas',
                    info: 'Ingresar las variables de calificación',
                    save: 'Guardar',
                    riesgoPais: 'Riesgo país', 
                    selectScore: 'Seleccione un Score',
                    calificacion: 'Calificación',
                    tasa: 'Tasa',
                    valor: 'Valor',
                    filterTasa: 'Filtrar tasa...',
                    filterValor: 'Filtrar valor...',
                };

            } else {

                return {
                    title: 'Rates',
                    info: 'Enter rating variables',
                    save: 'Guardar',
                    riesgoPais: 'Riesgo país',
                    selectScore: 'Select a Score',
                    calificacion: 'Qualification',
                    tasa: 'Rate',
                    valor: 'Value',
                    filterTasa: 'Filter rate...',
                    filterValor: 'Filtrar value...',
                };

            }

        },

        allFields(){
            return [
                { key: 'tasa', label: this.labels.tasa, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'valor', label: this.labels.valor, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'tasa', type: 'text', placeholder: this.labels.filterTasa },
                { key: 'valor', type: 'text', placeholder: this.labels.filterValor },
            ]
        },
        scoreOptions() {

            return this.listTasasScore.map(item => ({

                value: item.tipo_tasa,

                text: item.descripcion

            }));

        }
    },
    methods: {

        // =========================================================
        // TASA USD
        // =========================================================

        getTasaUSD(
            tasa_usa,
            tasa_libre_riesgo
        ) {

            const tasaUSD =
                parseFloat(tasa_usa || 0) +
                parseFloat(tasa_libre_riesgo || 0);

            return tasaUSD.toFixed(6);

        },


        // =========================================================
        // TASA FINAL USD
        // =========================================================

        getTasaFinalUSD(
            embi,
            tasaUsa,
            tasaLibRiesgo
        ) {

            const tasa_usd =
                parseFloat(tasaUsa || 0) +
                parseFloat(tasaLibRiesgo || 0);

            const operacion =
                parseFloat(embi || 0) +
                tasa_usd;

            return operacion.toFixed(6);

        },


        // =========================================================
        // DEVALUACIÓN
        // =========================================================

        getDevaluacion(
            inflacion_usa,
            inflacion_col
        ) {

            let devaluacion =
                (
                    (
                        1 +
                        parseFloat(inflacion_col / 100)
                    ) /
                    (
                        1 +
                        parseFloat(inflacion_usa / 100)
                    )
                - 1
                ) * 100;

            return devaluacion.toFixed(6);

        },


        // =========================================================
        // TASA PAÍS ORIGEN
        // =========================================================

        getTasaPaisOrigen(
            tasa_usa,
            tasa_libre_riesgo,
            inflacion_usa,
            inflacion_col
        ) {

            let tasaUSD =
                parseFloat(tasa_usa / 100) +
                parseFloat(tasa_libre_riesgo / 100);

            let devaluacion =
                (
                    (
                        1 +
                        parseFloat(inflacion_col / 100)
                    ) /
                    (
                        1 +
                        parseFloat(inflacion_usa / 100)
                    )
                ) - 1;

            let tasaPaisOrigen =
                (
                    (
                        1 + tasaUSD
                    ) *
                    (
                        1 + devaluacion
                    ) - 1
                ) * 100;

            return tasaPaisOrigen.toFixed(6);

        },


        // =========================================================
        // TASA FINAL
        // =========================================================

        getTasaFinal(
            embi,
            tasa_usa,
            tasa_libre_riesgo,
            inflacion_usa,
            inflacion_col
        ) {

            const tasaFinalUSD =
                parseFloat(
                    this.getTasaFinalUSD(
                        embi,
                        tasa_usa,
                        tasa_libre_riesgo
                    )
                );

            const calcula =
                tasaFinalUSD *
                (
                    (
                        1 +
                        parseFloat(inflacion_col || 0) / 100
                    ) /
                    (
                        1 +
                        parseFloat(inflacion_usa || 0) / 100
                    )
                );

            return calcula.toFixed(6);

        },


        // =========================================================
        // CONSULTAR INFORMACIÓN DE TASAS
        // =========================================================

        async f_lea_informacion() {

            /*
             * Cada vez que se cambia el Score:
             *
             * 1. Ocultamos la tabla.
             * 2. Limpiamos los datos anteriores.
             * 3. Consultamos nuevamente.
             */

            this.muestraInformacion = false;

            this.tableData = [];

            this.TasasByVigencia = {

                tasa_usa: '',
                embi: '',
                tasa_libre_riesgo: '',
                inflacion_usa: '',
                inflacion_col: '',

                calificacion:
                    this.calificacion,

                vigencia:
                    this.infoVigencia,

                tipo_tasa:
                    this.zscore

            };


            if (!this.zscore) {
                return;
            }


            this.loading = true;


            try {

                const res =
                    await ClasificacionTasas.getAllClasificacionTasas(

                        this.infoVigencia,

                        this.calificacion,

                        this.zscore

                    );


                this.listaTasas =
                    res.data.clasificacionTasa || [];


                /*
                 * El backend ya está filtrando:
                 *
                 * vigencia
                 * calificacion
                 * tipo_tasa
                 *
                 * Por lo tanto tomamos directamente
                 * el primer registro.
                 */

                if (this.listaTasas.length > 0) {

                    this.TasasByVigencia = {

                        ...this.TasasByVigencia,

                        ...this.listaTasas[0]

                    };

                    this.muestraInformacion = true;

                } else {

                    /*
                     * Si no existe clasificación para
                     * este Score no mostramos la tabla.
                     */

                    this.muestraInformacion = false;

                }


                /*
                 * Construimos la información de la tabla.
                 */

                if (this.muestraInformacion) {

                    this.buildTableData();

                }

            } catch (error) {

                console.log(
                    'Error consultando clasificación:',
                    error
                );

                this.muestraInformacion = false;

            } finally {

                this.loading = false;

            }

        },


        // =========================================================
        // ARMAR DATOS DE CORPORATEDATATABLE
        // =========================================================

        buildTableData() {

            const tasas =
                this.TasasByVigencia;


            const tasaUSD =
                this.getTasaUSD(
                    tasas.tasa_usa,
                    tasas.tasa_libre_riesgo
                );


            const tasaFinalUSD =
                this.getTasaFinalUSD(
                    tasas.embi,
                    tasas.tasa_usa,
                    tasas.tasa_libre_riesgo
                );


            const tasaFinal =
                this.getTasaFinal(
                    tasas.embi,
                    tasas.tasa_usa,
                    tasas.tasa_libre_riesgo,
                    tasas.inflacion_usa,
                    tasas.inflacion_col
                );


            this.tableData = [

                {
                    tasa: 'Tasa USA',
                    valor: tasas.tasa_usa
                },
                {
                    tasa: 'Tasa libre de riesgo',
                    valor: tasas.tasa_libre_riesgo
                },
                {
                    tasa: 'Tasa USD',
                    valor: tasaUSD
                },
                {
                    tasa: this.labels.riesgoPais,
                    valor: tasas.embi
                },
                {
                    tasa: 'Tasa final USD',
                    valor: tasaFinalUSD
                },
                {
                    tasa: 'Inflación USA',
                    valor: tasas.inflacion_usa
                },
                {
                    tasa: 'Inflación COL',
                    valor: tasas.inflacion_col
                },
                {
                    tasa: 'Tasa Final',
                    valor: tasaFinal
                }

            ];

        },


        // =========================================================
        // GUARDAR TASA
        // =========================================================

        async f_guardarTasa() {

            if (!this.zscore) {

                this.$toast.error(
                    'Seleccione un Score'
                );

                return;

            }


            if (!this.TasasByVigencia) {

                this.$toast.error(
                    'No existe información de tasas'
                );

                return;

            }


            try {

                const v_tasa_final =
                    this.getTasaFinal(

                        this.TasasByVigencia.embi,

                        this.TasasByVigencia.tasa_usa,

                        this.TasasByVigencia.tasa_libre_riesgo,

                        this.TasasByVigencia.inflacion_usa,

                        this.TasasByVigencia.inflacion_col

                    );


                console.log(
                    'Tasa final a guardar:',
                    v_tasa_final
                );


                await Tasas.grabeTasa(

                    this.infoVigencia,

                    this.zscore,

                    v_tasa_final,

                    this.$store.state.userId

                );


                this.$toast.success(
                    'Tasa guardada correctamente'
                );

            } catch (error) {

                console.log(
                    'Error guardando tasa:',
                    error
                );

                this.$toast.error(
                    'Problema al guardar la tasa'
                );

            }

        },


        // =========================================================
        // CARGAR CALIFICACIÓN
        // =========================================================

        async loadCalificacion() {

            try {

                const res =
                    await Score.getAllScorexByVigencia(
                        this.infoVigencia
                    );


                if (
                    res.data.qryScoreX &&
                    res.data.qryScoreX.length > 0
                ) {

                    this.calificacion =
                        res.data.qryScoreX[0].calificacion;

                } else {

                    this.calificacion = '';

                }

            } catch (error) {

                console.log(
                    'Error cargando calificación:',
                    error
                );

                this.calificacion = '';

            }

        },


        // =========================================================
        // CARGAR TIPOS DE SCORE
        // =========================================================

        async loadTiposScore() {

            try {

                const res =
                    await TipoTasa.leaTasasZScore();


                this.listTasasScore =
                    res.data.listTipoTasas || [];

            } catch (error) {

                console.log(
                    'Error cargando tipos de Score:',
                    error
                );

                this.listTasasScore = [];

            }

        },


        // =========================================================
        // CARGA INICIAL
        // =========================================================

        async loadData() {

            this.zscore = null;

            this.muestraInformacion = false;

            this.tableData = [];


            /*
             * Las dos consultas pueden ejecutarse
             * simultáneamente.
             */

            await Promise.all([

                this.loadCalificacion(),

                this.loadTiposScore()

            ]);

        }

    },
    mounted() {
        this.loadData();
    },
    watch: {
        infoVigencia: {

            immediate: false,

            async handler() {

                await this.loadData();

            }
        }
    }
};
</script>


<style scoped>

.uniform-modal-body {
    padding: 0.5rem 0;
}


.password-policy-title {
    font-weight: 600;
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0;
}


.password-policy-item {
    font-weight: 500;
    color: #57494b;
    font-size: 0.95rem;
    margin-bottom: 5;
}


.reset-select {
    width: 100%;
    padding: 0.5rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 6px;
    background-color: white;
    transition:
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
}


.reset-select:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow:
        0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}


.reset-btn-primary {
    background-color: #007bff;
    border: 1px solid #007bff;
    color: white;
    padding: 0.5rem 1.5rem;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.3s ease;
}


.reset-btn-primary:hover {
    background-color: #0069d9;
    border-color: #0062cc;
    color: white;
}


.reset-btn-primary:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}


/* =========================================================
   CORPORATEDATATABLE
   ========================================================= */
/*
::v-deep .corporate-data-table .table thead th {
    background-color: #2e507a !important;
    color: white !important;
    font-weight: 600;
    text-align: center;
    padding: 0.75rem;
    border-color: #1a3a5c;
}


::v-deep .corporate-data-table .table tbody td {
    padding: 0.65rem 0.75rem;
    vertical-align: middle;
}


::v-deep .corporate-data-table .table tbody tr:hover {
    background-color: #f8f9fa !important;
}


::v-deep .corporate-data-table .text-right {
    text-align: right !important;
}


::v-deep .corporate-data-table .text-center {
    text-align: center !important;
}


::v-deep .corporate-data-table .font-weight-bold {
    font-weight: 700 !important;
}


::v-deep .corporate-data-table .text-primary {
    color: #007bff !important;
}


::v-deep .corporate-data-table .text-muted {
    color: #6c757d !important;
}


@media (max-width: 768px) {

    ::v-deep .corporate-data-table .table {
        font-size: 0.8rem;
    }

    ::v-deep .corporate-data-table .table td,
    ::v-deep .corporate-data-table .table th {
        padding: 0.4rem 0.5rem;
    }

}
*/

</style>